package ai.flowstorm.studio.ui.builder

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.id.newId
import ai.flowstorm.common.model.AbstractEntity
import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.studio.resources.space.DialogueSourceResource
import ai.flowstorm.studio.resources.space.DialogueSourceResource.Build
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class BuildRequest(
    override val _id: Id = newId(),
    val space_id: Id = AppState.state.spaceId!!,
    val name: String = "",
    val description: String = "",
    var dialogues: MutableList<BuildItem> = mutableListOf(),
    val state: RequestState = RequestState.Stopped,
) : AbstractEntity() {
    override val label by this::name

    var dialoguesCountString = ""

    init {
        dialoguesCountString = dialogues.size.toString()
    }
    val stats
        get() = BuildStats(
            dialogues.size,
            dialogues.filter { it.state == ItemState.Failed }.size,
            dialogues.filter { it.state == ItemState.Built }.size,
            dialogues.filter { it.state == ItemState.NotStarted || it.state == ItemState.Building }.size,
        ).let { "${it.built}/${it.failed}/${it.notStarted}" }

    fun addDialogue(dialogue: BuildItem) {
        if (!dialogues.contains(dialogue)) {
            dialogues.add(dialogue)
        }
        dialoguesCountString = dialogues.size.toString()
    }

    fun addAllDialogues(dialogues: List<BuildItem>) {
        dialogues.forEach { addDialogue(it) }
    }

    fun clearDialogues() {
        dialogues.clear()
        dialoguesCountString = "0"
    }
}

data class BuildStats(
    val count: Int,
    val failed: Int,
    val built: Int,
    val notStarted: Int,
)

@Serializable
data class BuildItem(
    val dialogue_id: Id,
    val dialogueName: String,
    val state: ItemState = ItemState.NotStarted,
    val result: Build? = null,
)

enum class RequestState {
    Stopped,
    Pending,
    InProgress,
    Finished,
}

enum class ItemState {
    NotStarted,
    Building,
    Built,
    Failed,
}